import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { VideoExerciseView } from '../../views';
import { ExerciseViewProps } from '../exercises';

export function Module1S1ExerciseIntro({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    if (exercise.CurrentPage === 2) {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay1 className="mb-10">Tillad ubehaget</LabelDisplay1>
                <LabelBody>
                    Du vil nu blive guidet igennem de øvelser, der kan hjælpe
                    dig med at være med dine følelser og tanker på en anden
                    måde.
                </LabelBody>
                <SwirlyBox className="my-30">
                    Er du klar til at gå i gang?
                </SwirlyBox>
                <Spacer />
                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: true,
                        })
                    }
                >
                    Lad os komme i gang
                </SecondaryButton>
                <GhostButton
                    className="mt-20 self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: false,
                        })
                    }
                >
                    Vender tilbage senere
                </GhostButton>
            </Exercise>
        );
    } else {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay2 className="mb-10">
                    Hvad betyder det at tillade ubehag?
                </LabelDisplay2>
                <LabelBody>
                    Betyder det, at du bare skal lade det være og kan man
                    egentlig tænke sig ud af ubehag? I videoen vil du blive
                    præsenteret for, hvorfor det er en god ide at eksperimentere
                    med måden, du forholder dig til dine tanker og følelser på.
                    Når du er klar, kan du trykke på afspil.
                </LabelBody>

                <VideoExerciseView className="mt-20" exercise={exercise} />

                <Spacer class="mt-20" />

                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.InProgress,
                            pageNumber: 2,
                        })
                    }
                >
                    Videre
                </SecondaryButton>
            </Exercise>
        );
    }
}
